import React from 'react';

import css from './SimpleAppExperience.module.css';

/**
 * Progress dots + one-pager toggle for long create forms.
 */
export const ProgressiveFormChrome = ({
  steps,
  stepIndex,
  onePager,
  onToggleOnePager,
  onSelectStep,
}) => {
  if (!steps || steps.length <= 1) {
    return null;
  }

  const current = steps[stepIndex] || steps[0];

  return (
    <div className={css.progressChrome} data-testid="progressive-form-chrome">
      <div className={css.progressTop}>
        {!onePager ? (
          <p className={css.progressLabel}>
            Step {stepIndex + 1} of {steps.length}
            {current?.title ? ` · ${current.title}` : ''}
          </p>
        ) : (
          <p className={css.progressLabel}>All fields</p>
        )}
        <button
          type="button"
          className={css.progressToggle}
          onClick={onToggleOnePager}
          data-testid="progressive-one-pager-toggle"
        >
          {onePager ? 'Guide me step by step' : 'Show all at once'}
        </button>
      </div>
      {!onePager ? (
        <nav className={css.progressDots} aria-label="Form progress">
          {steps.map((step, idx) => (
            <button
              key={step.id}
              type="button"
              className={
                idx === stepIndex
                  ? `${css.progressDot} ${css.progressDotActive}`
                  : idx < stepIndex
                    ? `${css.progressDot} ${css.progressDotDone}`
                    : css.progressDot
              }
              aria-label={step.title}
              aria-current={idx === stepIndex ? 'step' : undefined}
              onClick={() => idx <= stepIndex && onSelectStep?.(idx)}
            />
          ))}
        </nav>
      ) : null}
    </div>
  );
};

export default ProgressiveFormChrome;
